<template>
  <div class="trems">
    <section class="g-bg-gray-light-v5">
      <div class="container g-py-50">
        <div class="text-center">
          <div class="align-self-center">
            <h2 class="h3 g-font-weight-300 w-100 g-mb-10 g-mb-0--md">智郵易服務使用條款</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="container g-py-100">
      <div v-html="terms.content" v-if="terms"></div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Terms',
  mounted() {
    this.fetchTerms();
  },
  data() {
    return {
      terms: null,
    };
  },
  methods: {
    fetchTerms() {
      this.$api.app.terms().then(({ data: response }) => {
        this.terms = response.data;
      });
    },
  },
};
</script>
